'use strict';/* global define */define('modules/departments/directives/department-form/controller',['require','exports','module'],function(require,exports,module){'use strict';// @ngInject
     controller.$inject = ["$scope", "Departments", "Modals", "_"];
function controller($scope,Departments,Modals,_){// jshint validthis:true
// jshint latedef:false
var ctrl=this;// only pick what we need because
// there might be some circular data structure
// included in this model, which
// leads to complete desaster.
ctrl.department=_getSimplifiedClone($scope.department);ctrl.busy=false;ctrl.saveDepartment=saveDepartment;ctrl.undoDepartment=undoDepartment;// ---
/**
     * Save department details
     *
     * @tested
     */function saveDepartment(){ctrl.busy=true;Departments.update({id:ctrl.department.id},ctrl.department).$promise.then(function(department){_.extend($scope.department,department);ctrl.department=_getSimplifiedClone($scope.department);$scope.departmentsForm.$setPristine();}).catch(Modals.fail).finally(function(){ctrl.busy=false;});}/**
     * Restore beginning state
     */function undoDepartment(){ctrl.department=_getSimplifiedClone($scope.department);$scope.departmentsForm.$setPristine();}/**
     * Get a clone of the department
     *
     * @param  {Object} department - department
     * @return {Object}            - simplified clone of the department
     */function _getSimplifiedClone(department){return _.pick(department,['id','name','description']);}}module.exports=controller;});
